export async function runBulk<T, P>(
  items: Iterable<T>,
  fn: (item: T) => Promise<P> | P,
  onError: (e: Error) => void,
): Promise<P[]> {
  const iterator = items[Symbol.iterator]();
  const promises = [];
  while (true) {
    const { value, done } = iterator.next();
    if (done) {
      break;
    }
    promises.push(fn(value));
  }

  const results = await Promise.allSettled(promises);
  const finished = [];
  for (const r of results) {
    if (r.status === 'fulfilled') {
      finished.push(r.value);
    } else {
      onError(r.reason);
    }
  }
  return finished;
}
